export default __webpack_public_path__ + "static/media/CEO.6c9cfa7f.png";